export const CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const LOGO_URL =
  "https://api.logo.com/api/v2/images?logo=logo_6e448f94-590d-4acb-a41c-16169c35fffa&format=webp&margins=0&quality=60&width=500&background=transparent&u=1693480798";

export const MENU_API_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=25.6368743&lng=85.0547624&restaurantId=";
